import React from 'react';

// Components

import Page1_00 from '../../../components/ssap/pages/Page1_00';
import Page1_01 from '../../../components/ssap/pages/Page1_01';
import Page1_02 from '../../../components/ssap/pages/Page1_02';
import Page1_03 from '../../../components/ssap/pages/Page1_03';
import Page1_04 from '../../../components/ssap/pages/Page1_04';
import Page1_05 from '../../../components/ssap/pages/Page1_05';
import Page2_07 from '../../../components/ssap/pages/Page2_07';
import Page2_08 from '../../../components/ssap/pages/Page2_08';
import Page2_09 from '../../../components/ssap/pages/Page2_09';
import Page2_10 from '../../../components/ssap/pages/Page2_10';
import Page2_11_mod2 from '../../../components/ssap/pages/Page2_11_mod2';
import Page2_12 from '../../../components/ssap/pages/Page2_12';
import Page2_13 from '../../../components/ssap/pages/Page2_13';
import Page2_14 from '../../../components/ssap/pages/Page2_14';
import Page2_15 from '@components/ssap/pages/Page2_15';
import Page3_15 from '../../../components/ssap/pages/Page3_15';
import Page3_16 from '../../../components/ssap/pages/Page3_16';
import Page3_17 from '../../../components/ssap/pages/Page3_17';
import Page2_21 from '../../../components/ssap/pages/Page2_21';
import Page2_22 from '../../../components/ssap/pages/Page2_22';
import Page2_23 from '../../../components/ssap/pages/Page2_23';
import Page2_24 from '../../../components/ssap/pages/Page2_24';
import Page2_25 from '../../../components/ssap/pages/Page2_25';
import Page2_26 from '../../../components/ssap/pages/Page2_26';
import Page2_27 from '../../../components/ssap/pages/Page2_27';
import Page1_03_E1 from '../../../components/ssap/pages/Page1_03_E1';
import Page3_31_E1 from '../../../components/ssap/pages/Page3_31_E1';
import Page3_32_E1 from '../../../components/ssap/pages/Page3_32_E1';
import Page3_33_E1 from '../../../components/ssap/pages/Page3_33_E1';
import Page3_34_E1 from '../../../components/ssap/pages/Page3_34_E1';
import Page3_35_E1 from '../../../components/ssap/pages/Page3_35_E1';
import Page3_36_E1 from '../../../components/ssap/pages/Page3_36_E1';
import Page3_37_E1 from '../../../components/ssap/pages/Page3_37_E1';
import Page3_38_E4 from '../../../components/ssap/pages/Page3_38_E4';
import Page4_61 from '../../../components/ssap/pages/Page4_61';
import Page4_62 from '../../../components/ssap/pages/Page4_62';
import Page4_63 from '../../../components/ssap/pages/Page4_63';
import Page4_64 from '../../../components/ssap/pages/Page4_64';
import Page4_65 from '../../../components/ssap/pages/Page4_65';
import Page4_66 from '../../../components/ssap/pages/Page4_66';
import Page4_MedicalEmergency from '@components/ssap/pages/Page4_MedicalEmergency';
import Page4_67_E5 from '../../../components/ssap/pages/Page4_67_E5';
import Page1_07_E2 from '../../../components/ssap/pages/Page1_07_E2';
import Page2_07_E2_mod1 from '../../../components/ssap/pages/Page2_07_E2_mod1';
import Page2_28_E3 from '../../../components/ssap/pages/Page2_28_E3';
import Page2_29_E5 from '../../../components/ssap/pages/Page2_29_E5';

// Utils

import { questionsVisibility } from '../../../utils/miscellaneous/pageAndQuestionsVisibility';

// Constants

import buttonsTypes from '../buttons/buttonsTypes';
import { PAGES } from './pagesTypes';
import { ENABLED, SSAP_FLOW_VERSION } from '../miscellaneous/miscellaneous';
import { UNEMPLOYMENT_INCOME_ATTESTATION_SUPPORTED_YEARS } from '../miscellaneous/miscellaneous';
import { COMMUNICATION_PREFERENCES, IMMIGRATION_INFO, SSNS } from '../../../APIs/common/endpoints';





const {
    ABOUT_YOUR_HOUSEHOLD_PAGE,
    ACTIVE_MILITARY_VETERAN_PAGE,
    ADDITIONAL_INFORMATION_SUMMARY_PAGE,
    ADDITIONAL_INFORMATION_PAGE,
    AMERICAN_INDIAN_ALASKA_NATIVE_PAGE,
    APPLICANTS_PAGE,
    APPLICATION_ASSISTANCE_PAGE,
    BEFORE_WE_BEGIN_PAGE,
    CITIZENSHIP_IMMIGRATION_STATUS_PAGE,
    DISABILITY_INFORMATION_PAGE,
    DEDUCTION_SOURCES_PAGE,
    EMPLOYER_COVERAGE_DETAIL_PAGE,
    ETHNICITY_AND_RACE_PAGE,
    EXPECTED_INCOME_PAGE,
    EXTRA_FINAL_APPLICATION_REVIEW_PAGE,
    FOSTER_CARE_INFORMATION_PAGE,
    FAMILY_AND_HOUSEHOLD_SUMMARY_PAGE,
    FINAL_APPLICATION_REVIEW_PAGE,
    FULL_TIME_STUDENT_PAGE,
    GET_READY_FOR_HOUSEHOLD_AND_FAMILY_PAGE,
    GET_READY_FOR_INCOME_PAGE,
    GET_READY_PAGE,
    HEALTH_REIMBURSEMENT_ARRANGEMENT_DETAIL_PAGE,
    HELP_PAYING_FOR_COVERAGE_PAGE,
    HOUSEHOLD_SUMMARY_PAGE,
    INCOME_DISCREPANCY_PAGE,
    INCOME_INFORMATION_SUMMARY_PAGE,
    INCOME_SOURCES_PAGE,
    MARITAL_STATUS,
    MEDICAID_CHIP_DENIAL_INFORMATION_PAGE,
    MEDICAID_TERMINATION_DETAILS_PAGE,
    MEDICAL_EMERGENCY_STATUS_PAGE,
    OTHER_ADDRESSES_PAGE,
    OTHER_HEALTH_COVERAGE_PAGE,
    PARENT_CARETAKER_INFORMATION_PAGE,
    PREGNANCY_INFORMATION_PAGE,
    PERSONAL_INCOME_SUMMARY_PAGE,
    PERSONAL_INFORMATION_PAGE,
    PRIMARY_CONTACT_INFORMATION_PAGE,
    RECONCILIATION_IN_APTC_PAGE,
    RELATIONSHIPS_PAGE,
    RESIDENCY_INFORMATION_PAGE,
    REVIEW_AND_SIGN_PAGE,
    SIGN_AND_SUBMIT_PAGE,
    STATE_EMPLOYEE_HEALTH_BENEFIT_PAGE,
    TAX_HOUSEHOLD_COMPOSITION_PAGE,
    TRIBAL_SOURCE_INCOME_PAGE,
} = PAGES;



// Typical buttons schemes

const INITIAL_BUTTON_SCHEME = {
    leftButton: buttonsTypes.INITIAL_BTN,
    middleButton: buttonsTypes.DEFAULT_BTN,
    rightButton: buttonsTypes.COMBINED_BTN
};

const DEFAULT_BUTTONS_SCHEME = {
    leftButton: buttonsTypes.DEFAULT_BTN,
    middleButton: buttonsTypes.DEFAULT_BTN,
    rightButton: buttonsTypes.COMBINED_BTN
};

const DEFAULT_BUTTONS_WITH_CONTINUE_ONE_SCHEME = {
    leftButton: buttonsTypes.DEFAULT_BTN,
    middleButton: buttonsTypes.HIDDEN_BTN,
    rightButton: buttonsTypes.DEFAULT_BTN
};



// Flows combining: start


const PAGE_FLOW_SWITCHER = {
    pageName: HELP_PAYING_FOR_COVERAGE_PAGE,
    navBarText: 'ssap.page_title.help_paying_fot_coverage',
    component: <Page1_03_E1/>,
    componentName: 'Page1_03_E1',
    buttons: DEFAULT_BUTTONS_SCHEME,
    formName: 'financialAssistanceForm'
};

const START_SECTION_NFF = {
    sectionName: 'ssap.section_title.start',
    subSections: [
        {
            pageName: BEFORE_WE_BEGIN_PAGE,
            navBarText: 'ssap.page_title.before_we_begin',
            component: <Page1_00/>,
            componentName: 'Page1_00',
            buttons: INITIAL_BUTTON_SCHEME,
            formName: 'beforeWeBeginForm'
        },
        {
            pageName: EXTRA_FINAL_APPLICATION_REVIEW_PAGE,
            navBarText: 'ssap.page_title.extra_final_review',
            component: <Page3_16/>,
            componentName: 'Page3_16',
            buttons: {
                ...DEFAULT_BUTTONS_WITH_CONTINUE_ONE_SCHEME,
                editButton_secondary: buttonsTypes.DEFAULT_BTN
            }
        },
        {
            pageName: GET_READY_PAGE,
            navBarText: 'ssap.page_title.get_ready',
            component: <Page1_01/>,
            componentName: 'Page1_01',
            buttons: DEFAULT_BUTTONS_WITH_CONTINUE_ONE_SCHEME
        },
        {
            pageName: PRIMARY_CONTACT_INFORMATION_PAGE,
            navBarText: 'ssap.page_title.primary_contact_info',
            component: <Page1_02/>,
            componentName: 'Page1_02',
            buttons: DEFAULT_BUTTONS_SCHEME,
            formName: 'primaryContactForm',
            asyncQueries: { queryType: COMMUNICATION_PREFERENCES }
        },
        {
            pageName: APPLICATION_ASSISTANCE_PAGE,
            navBarText: 'ssap.page_title.applying_for_coverage',
            component: <Page1_03/>,
            componentName: 'Page1_03',
            buttons: DEFAULT_BUTTONS_SCHEME,
            formName: 'assistanceForm'
        },
        {
            pageName: APPLICANTS_PAGE,
            navBarText: 'ssap.page_title.who_needs_coverage',
            component: <Page1_04/>,
            componentName: 'Page1_04',
            buttons: DEFAULT_BUTTONS_SCHEME,
            formName: 'applyingForCoverageForm'
        },
        {
            pageName: ABOUT_YOUR_HOUSEHOLD_PAGE,
            navBarText: 'ssap.page_title.about_household',
            component: <Page1_05/>,
            componentName: 'Page1_05',
            buttons: {
                ...DEFAULT_BUTTONS_SCHEME,
                removeMemberButton: buttonsTypes.DEFAULT_BTN,
                addPersonButton: buttonsTypes.DEFAULT_BTN,
            },
            extraButtons: {
                addPersonButton: buttonsTypes.DEFAULT_BTN,
            },
            formName: 'householdMembersForm'
        },
        {
            pageName: RELATIONSHIPS_PAGE,
            navBarText: 'ssap.page_title.household_relationships',
            component: <Page2_13/>,
            componentName: 'Page2_13',
            buttons: DEFAULT_BUTTONS_SCHEME,
            formName: 'relationshipsForm'
        },
        {
            pageName: OTHER_ADDRESSES_PAGE,
            navBarText: 'ssap.page_title.household_addresses',
            component: <Page2_11_mod2/>,
            componentName: 'Page2_11_mod2',
            buttons: DEFAULT_BUTTONS_SCHEME,
            formName: 'otherAddressesForm'
        },
        {
            pageName: RESIDENCY_INFORMATION_PAGE,
            navBarText: 'ssap.page_title.residency_information',
            component: <Page2_15/>,
            componentName: 'Page2_15',
            buttons: DEFAULT_BUTTONS_SCHEME,
            formName: 'residencyInformationForm'
        },
        {
            pageName: HOUSEHOLD_SUMMARY_PAGE,
            navBarText: 'ssap.page_title.summary',
            component: <Page1_07_E2/>,
            componentName: 'Page1_07_E2',
            buttons: {
                ...DEFAULT_BUTTONS_WITH_CONTINUE_ONE_SCHEME,
                editButton_secondary: buttonsTypes.DEFAULT_BTN,
            }
        }
    ]
};

const START_SECTION_FF = {
    ...START_SECTION_NFF,
    subSections: START_SECTION_NFF.subSections
        .reduce((ss, s) => {
            return s.pageName === APPLICATION_ASSISTANCE_PAGE ?
                [
                    ...ss,
                    s,
                    PAGE_FLOW_SWITCHER
                ] :
                [
                    ...ss,
                    s
                ];
        }, [ ])
};

const FAMILY_SECTION_NFF = {
    sectionName: 'ssap.section_title.family',
    subSections: [
        {
            pageName: GET_READY_FOR_HOUSEHOLD_AND_FAMILY_PAGE,
            navBarText: 'ssap.page_title.get_ready',
            component:  <Page2_07/>,
            componentName: 'Page2_07',
            buttons: DEFAULT_BUTTONS_WITH_CONTINUE_ONE_SCHEME
        },
        [
            {
                pageName: PERSONAL_INFORMATION_PAGE,
                navBarText: 'ssap.page_title.personal_information',
                component: <Page2_08/>,
                componentName: 'Page2_08',
                buttons: DEFAULT_BUTTONS_SCHEME,
                formName: 'personalInfoForm',
                asyncQueries: { queryType: SSNS }
            },
            {
                pageName: CITIZENSHIP_IMMIGRATION_STATUS_PAGE,
                navBarText: 'ssap.page_title.cis',
                component: <Page2_09/>,
                componentName: 'Page2_09',
                buttons: DEFAULT_BUTTONS_SCHEME,
                formName: 'citizenshipImmigrationForm',
                asyncQueries: { queryType: IMMIGRATION_INFO }
            },
            {
                pageName: ETHNICITY_AND_RACE_PAGE,
                navBarText: 'ssap.page_title.ethnicity_and_race',
                component: <Page2_10/>,
                componentName: 'Page2_10',
                buttons: DEFAULT_BUTTONS_SCHEME,
                formName: 'ethnicityRaceForm'
            }
        ],
        {
            pageName: ACTIVE_MILITARY_VETERAN_PAGE,
            navBarText: 'ssap.page_title.military_service',
            component: <Page2_25/>,
            componentName: 'Page2_25',
            buttons: DEFAULT_BUTTONS_SCHEME,
            formName: 'militaryServiceForm'
        },
        {
            pageName: AMERICAN_INDIAN_ALASKA_NATIVE_PAGE,
            navBarText: 'ssap.page_title.ai_an',
            component: <Page2_12/>,
            componentName: 'Page2_12',
            buttons: DEFAULT_BUTTONS_SCHEME,
            formName: 'americanNativeForm'
        },
        {
            pageName: FAMILY_AND_HOUSEHOLD_SUMMARY_PAGE,
            navBarText: 'ssap.page_title.summary',
            component: <Page2_14/>,
            componentName: 'Page2_14',
            buttons: {
                ...DEFAULT_BUTTONS_WITH_CONTINUE_ONE_SCHEME,
                editButton_secondary: buttonsTypes.DEFAULT_BTN,
            }
        }
    ]
};

const FAMILY_SECTION_FF = {
    sectionName: 'ssap.section_title.family',
    subSections: [
        {
            pageName: GET_READY_FOR_HOUSEHOLD_AND_FAMILY_PAGE,
            navBarText: 'ssap.page_title.get_ready',
            component: <Page2_07/>,
            componentName: 'Page2_07',
            buttons: DEFAULT_BUTTONS_WITH_CONTINUE_ONE_SCHEME
        },
        [
            {
                pageName: PERSONAL_INFORMATION_PAGE,
                navBarText: 'ssap.page_title.personal_information',
                component: <Page2_08/>,
                componentName: 'Page2_08',
                buttons: DEFAULT_BUTTONS_SCHEME,
                formName: 'personalInfoForm',
                asyncQueries: { queryType: SSNS }
            },
            {
                pageName: CITIZENSHIP_IMMIGRATION_STATUS_PAGE,
                navBarText: 'ssap.page_title.cis',
                component: <Page2_09/>,
                componentName: 'Page2_09',
                buttons: DEFAULT_BUTTONS_SCHEME,
                formName: 'citizenshipImmigrationForm',
                asyncQueries: { queryType: IMMIGRATION_INFO }
            },
            {
                pageName: ETHNICITY_AND_RACE_PAGE,
                navBarText: 'ssap.page_title.ethnicity_and_race',
                component: <Page2_10/>,
                componentName: 'Page2_10',
                buttons: DEFAULT_BUTTONS_SCHEME,
                formName: 'ethnicityRaceForm'
            },
            {
                pageName: MARITAL_STATUS,
                navBarText: 'ssap.page_title.marital_status',
                component: <Page2_28_E3/>,
                componentName: 'Page2_28_E3',
                buttons: {
                    ...DEFAULT_BUTTONS_SCHEME,
                    updateInformationButton: buttonsTypes.SPOUSE_BTN,
                    fixRelationshipButton: buttonsTypes.SPOUSE_BTN
                },
                formName: 'maritalStatusForm'
            },
            {
                pageName: PARENT_CARETAKER_INFORMATION_PAGE,
                navBarText: 'ssap.page_title.parent_caretaker_info',
                component: <Page2_26/>,
                componentName: 'Page2_26',
                buttons: DEFAULT_BUTTONS_SCHEME,
                formName: 'parentCaretakerForm'
            },
        ],
        {
            pageName: ACTIVE_MILITARY_VETERAN_PAGE,
            navBarText: 'ssap.page_title.military_service',
            component: <Page2_25/>,
            componentName: 'Page2_25',
            buttons: DEFAULT_BUTTONS_SCHEME,
            formName: 'militaryServiceForm'
        },
        {
            pageName: TAX_HOUSEHOLD_COMPOSITION_PAGE,
            navBarText: 'ssap.page_title.household_info',
            component: <Page2_07_E2_mod1/>,
            componentName: 'Page2_07_E2_mod1',
            buttons: {
                ...DEFAULT_BUTTONS_SCHEME,
                updateInformationButton: buttonsTypes.DEFAULT_BTN
            },
            formName: 'taxHouseholdCompositionForm'
        },
        {
            pageName: AMERICAN_INDIAN_ALASKA_NATIVE_PAGE,
            navBarText: 'ssap.page_title.ai_an',
            component: <Page2_12/>,
            componentName: 'Page2_12',
            buttons: DEFAULT_BUTTONS_SCHEME,
            formName: 'americanNativeForm'
        },
        {
            pageName: MEDICAID_TERMINATION_DETAILS_PAGE,
            navBarText: 'ssap.page_title.medicaid_termination_details',
            component: <Page2_29_E5/>,
            componentName: 'Page2_29_E5',
            buttons: DEFAULT_BUTTONS_SCHEME,
            formName: 'medicaidTerminationDetailsForm'
        },
        {
            pageName: MEDICAID_CHIP_DENIAL_INFORMATION_PAGE,
            navBarText: 'ssap.page_title.medicaid_chip_info',
            component: <Page2_21/>,
            componentName: 'Page2_21',
            buttons: DEFAULT_BUTTONS_SCHEME,
            formName: 'medicaidChipDenialForm'
        },
        {
            pageName: PREGNANCY_INFORMATION_PAGE,
            navBarText: 'ssap.page_title.pregnancy_info',
            component: <Page2_22/>,
            componentName: 'Page2_22',
            buttons: DEFAULT_BUTTONS_SCHEME,
            formName: 'pregnancyForm'
        },
        {
            pageName: DISABILITY_INFORMATION_PAGE,
            navBarText: 'ssap.page_title.disability_info',
            component: <Page2_23/>,
            componentName: 'Page2_23',
            buttons: DEFAULT_BUTTONS_SCHEME,
            formName: 'disabilityForm'
        },
        {
            pageName: FOSTER_CARE_INFORMATION_PAGE,
            navBarText: 'ssap.page_title.foster_care_info',
            component: <Page2_24/>,
            componentName: 'Page2_24',
            buttons: DEFAULT_BUTTONS_SCHEME,
            formName: 'fosterCareForm'
        },
        {
            pageName: FULL_TIME_STUDENT_PAGE,
            navBarText: 'ssap.page_title.full_time_student',
            component: <Page2_27/>,
            componentName: 'Page2_27',
            buttons: DEFAULT_BUTTONS_SCHEME,
            formName: 'fullTimeStudentForm'
        },
        {
            pageName: FAMILY_AND_HOUSEHOLD_SUMMARY_PAGE,
            navBarText: 'ssap.page_title.summary',
            component: <Page2_14/>,
            componentName: 'Page2_14',
            buttons: {
                ...DEFAULT_BUTTONS_WITH_CONTINUE_ONE_SCHEME,
                editButton_secondary: buttonsTypes.DEFAULT_BTN,
            }
        }
    ]
};

const INCOME_SECTION = {
    sectionName: 'ssap.section_title.income',
    subSections: [
        {
            pageName: GET_READY_FOR_INCOME_PAGE,
            navBarText: 'ssap.page_title.get_ready',
            component: <Page3_31_E1/>,
            componentName: 'Page3_31_E1',
            buttons: DEFAULT_BUTTONS_WITH_CONTINUE_ONE_SCHEME,
            formName: 'getReadyIncomeSection',
            runtimeOverride: (ss, ...args) => {
                const [ coverageYear ] = args;
                switch(true) {
                    case UNEMPLOYMENT_INCOME_ATTESTATION_SUPPORTED_YEARS.some(y => y === coverageYear):
                        return {
                            ...ss,
                            formName: 'getReadyIncomeSection',
                            buttons: { ...DEFAULT_BUTTONS_SCHEME }
                        };
                    default:
                        return ss;
                }
            }
        },
        [
            {
                pageName: INCOME_SOURCES_PAGE,
                navBarText: 'ssap.page_title.income_sources',
                component: <Page3_32_E1/>,
                componentName: 'Page3_32_E1',
                buttons: {
                    ...DEFAULT_BUTTONS_SCHEME,
                    addIncomeSourceButton: buttonsTypes.DEFAULT_BTN,
                    editButton_secondary_with_icon: buttonsTypes.DEFAULT_BTN,
                    removeButton_with_icon: buttonsTypes.DEFAULT_BTN,
                },
                formName: 'incomeSourcesForm'
            },
            {
                pageName: TRIBAL_SOURCE_INCOME_PAGE,
                navBarText: 'ssap.page_title.tribal_income',
                component: <Page3_33_E1/>,
                componentName: 'Page3_33_E1',
                buttons: {
                    ...DEFAULT_BUTTONS_SCHEME
                },
                formName: 'tribalSourceForm'
            },
            {
                pageName: DEDUCTION_SOURCES_PAGE,
                navBarText: 'ssap.page_title.deduction_sources',
                component: <Page3_34_E1/>,
                componentName: 'Page3_34_E1',
                buttons: {
                    ...DEFAULT_BUTTONS_SCHEME,
                    addDeductionSourceButton: buttonsTypes.DEFAULT_BTN,
                    editButton_secondary_with_icon: buttonsTypes.DEFAULT_BTN,
                    removeButton_with_icon: buttonsTypes.DEFAULT_BTN,
                },
                formName: 'deductionSourcesForm'
            },
            {
                pageName: EXPECTED_INCOME_PAGE,
                navBarText: 'ssap.page_title.expected_income',
                component: <Page3_35_E1/>,
                componentName: 'Page3_35_E1',
                buttons: {
                    ...DEFAULT_BUTTONS_SCHEME,
                    addDeductionSourceButton: buttonsTypes.DEFAULT_BTN,
                    editButton_secondary: buttonsTypes.DEFAULT_BTN,
                    removeButton: buttonsTypes.DEFAULT_BTN,
                },
                formName: 'expectedIncomeForm'
            },
            {
                pageName: PERSONAL_INCOME_SUMMARY_PAGE,
                navBarText: 'ssap.page_title.summary',
                component: <Page3_36_E1/>,
                componentName: 'Page3_36_E1',
                buttons: {
                    ...DEFAULT_BUTTONS_WITH_CONTINUE_ONE_SCHEME,
                    editButton_secondary: buttonsTypes.DEFAULT_BTN
                }
            }
        ],
        {
            pageName: INCOME_DISCREPANCY_PAGE,
            navBarText: 'ssap.page_title.income_discrepancy',
            component: <Page3_38_E4/>,
            componentName: 'Page3_38_E4',
            buttons: { ...DEFAULT_BUTTONS_SCHEME },
            formName: 'incomeDiscrepancyForm'
        },
        {
            pageName: INCOME_INFORMATION_SUMMARY_PAGE,
            navBarText: 'ssap.page_title.income_summary',
            component: <Page3_37_E1/>,
            componentName: 'Page3_37_E1',
            buttons: {
                ...DEFAULT_BUTTONS_WITH_CONTINUE_ONE_SCHEME,
                editButton_secondary: buttonsTypes.DEFAULT_BTN,
            }
        }
    ]
};

const ADDITIONAL_INFO_SECTION = {
    sectionName: 'ssap.section_title.additional',
    subSections: [
        [
            {
                pageName: OTHER_HEALTH_COVERAGE_PAGE,
                navBarText: 'ssap.page_title.other_health_coverage',
                component: <Page4_61/>,
                componentName: 'Page4_61',
                buttons: DEFAULT_BUTTONS_SCHEME,
                formName: 'otherHealthCoverageForm'
            },
            {
                pageName: RECONCILIATION_IN_APTC_PAGE,
                navBarText: 'ssap.page_title.reconciliation_of_aptc',
                component: <Page4_62/>,
                componentName: 'Page4_62',
                buttons: DEFAULT_BUTTONS_SCHEME,
                formName: 'reconciliationAptcForm'
            },
            {
                pageName: EMPLOYER_COVERAGE_DETAIL_PAGE,
                navBarText: 'ssap.page_title.employer_coverage_detail',
                component: <Page4_63/>,
                componentName: 'Page4_63',
                buttons: {
                    ...DEFAULT_BUTTONS_SCHEME,
                    addEmployerCoverageDetailButton: buttonsTypes.DEFAULT_BTN
                },
                formName: 'employerCoverageDetailsForm'
            },
            {
                pageName: HEALTH_REIMBURSEMENT_ARRANGEMENT_DETAIL_PAGE,
                navBarText: 'ssap.page_title.health_reimbursement_arrangement',
                component: <Page4_67_E5/>,
                componentName: 'Page4_67_E5',
                buttons: {
                    ...DEFAULT_BUTTONS_SCHEME,
                    addHraDetailButton: buttonsTypes.DEFAULT_BTN
                },
                formName: 'healthReimbursementArrangementForm'
            },
            {
                pageName: STATE_EMPLOYEE_HEALTH_BENEFIT_PAGE,
                navBarText: 'ssap.page_title.state_employee_health_benefit',
                component: <Page4_65/>,
                componentName: 'Page4_65',
                buttons: {
                    ...DEFAULT_BUTTONS_SCHEME
                },
                formName: 'stateEmployeeHealthBenefitForm'
            },
            {
                pageName: ADDITIONAL_INFORMATION_PAGE,
                navBarText: 'ssap.page_title.additional_information',
                component: <Page4_66/>,
                componentName: 'Page4_66',
                buttons: {
                    ...DEFAULT_BUTTONS_SCHEME
                },
                formName: 'additionalInfoForm'
            },
            {
                pageName: MEDICAL_EMERGENCY_STATUS_PAGE,
                navBarText: 'ssap.page_title.medical_emergency_status',
                component: <Page4_MedicalEmergency />,
                componentName: 'Page4_MedicalEmergency',
                buttons: {
                    ...DEFAULT_BUTTONS_SCHEME
                },
                formName: 'medicalEmergencyForm'
            }
        ],
        {
            pageName: ADDITIONAL_INFORMATION_SUMMARY_PAGE,
            navBarText: 'ssap.page_title.summary',
            component: <Page4_64/>,
            componentName: 'Page4_64',
            buttons: {
                ...DEFAULT_BUTTONS_WITH_CONTINUE_ONE_SCHEME,
                editButton_secondary: buttonsTypes.DEFAULT_BTN
            }

        }
    ]
};

const REVIEW_SECTION = {
    sectionName: 'ssap.section_title.review',
    subSections: [
        {
            pageName: REVIEW_AND_SIGN_PAGE,
            navBarText: 'ssap.page_title.review_and_sign',
            component: <Page3_15/>,
            componentName: 'Page3_15',
            buttons: DEFAULT_BUTTONS_WITH_CONTINUE_ONE_SCHEME
        },
        {
            pageName: FINAL_APPLICATION_REVIEW_PAGE,
            navBarText: 'ssap.page_title.final_review',
            component: <Page3_16/>,
            componentName: 'Page3_16',
            buttons: {
                ...DEFAULT_BUTTONS_WITH_CONTINUE_ONE_SCHEME,
                editButton_secondary: buttonsTypes.DEFAULT_BTN,
                downloadButton: buttonsTypes.INITIAL_BTN,
                printButton: buttonsTypes.INITIAL_BTN
            },
            formName: 'showUpdatedFieldsForm'
        },
        {
            pageName: SIGN_AND_SUBMIT_PAGE,
            navBarText: 'ssap.page_title.sign_and_submit',
            component: <Page3_17/>,
            componentName: 'Page3_17',
            buttons: {
                leftButton: buttonsTypes.DEFAULT_BTN,
                middleButton: buttonsTypes.HIDDEN_BTN,
                rightButton: buttonsTypes.SWITCHED_TO_SUBMIT_APPLICATION_BTN,
                editButton_secondary: buttonsTypes.DEFAULT_BTN
            },
            formName: 'signAndSubmitApplicationForm'
        }
    ]
};


const NON_FINANCIAL_FLOW_NON_SWITCHABLE = [
    START_SECTION_NFF,
    FAMILY_SECTION_NFF,
    REVIEW_SECTION
];

const NON_FINANCIAL_FLOW_SWITCHABLE = [
    START_SECTION_FF,
    FAMILY_SECTION_NFF,
    REVIEW_SECTION
];

const FINANCIAL_FLOW = [
    START_SECTION_FF,
    FAMILY_SECTION_FF,
    INCOME_SECTION,
    ADDITIONAL_INFO_SECTION,
    REVIEW_SECTION
];

// Flows combining: end





// Flows postprocessing

export const processSection = (section, idx, conditions) => {
    const {
        flowVersion,
        isExtraFinalSummaryShown
    } = conditions;

    if (idx === 0) {
        if(flowVersion === 2) {
            section = {
                ...section,
                subSections: section.subSections.filter(ss => ss.pageName !== APPLICANTS_PAGE)
            };
        }

        if(!isExtraFinalSummaryShown) {
            section = {
                ...section,
                subSections: section.subSections.filter(ss => ss.pageName !== EXTRA_FINAL_APPLICATION_REVIEW_PAGE)
            };
        }

        if(isExtraFinalSummaryShown) {
            section = {
                ...section,
                subSections: section.subSections.filter(ss => ss.pageName !== GET_READY_PAGE)
            };
        }
    }

    return section;
};

export const overrideProps = params => {

    const {
        hhm,
        serverDate,
        settings,
        subsection
    } = params;

    const overrides = {
        [PAGES.ETHNICITY_AND_RACE_PAGE]: {
            navBarText: 'ssap.page_title.ethnicity_and_race_sogi'
        }
    };

    const { pageName } = subsection;

    const override = overrides[pageName];

    if(!override) {
        return subsection;
    }

    switch(pageName) {
        case PAGES.ETHNICITY_AND_RACE_PAGE: {
            const isSogiShown = questionsVisibility.isSogiShown({
                hhm,
                isSogiFeatureEnabled: settings.sogiFeature === ENABLED,
                serverDate
            });

            switch(true) {
                case isSogiShown:
                    return  {
                        ...subsection,
                        ...override
                    };
                default:
                    return subsection;
            }
        }
    }
};

export const preparePagesForCurrentFlow = () => {

    const cachedFlows = new Map();

    const getComponentName = ({ componentName }) => `<${componentName}/>`;

    return function({
        flowType,
        hhmsQty,
        householdMembers = [],
        coverageYear = 0,
        isExtraFinalSummaryShown = false,
        serverDate = null,
        settings
    }) {

        const hhmDatesOfBirth = householdMembers.map(hhm => hhm.dateOfBirth).toString();

        const key = `${flowType}${hhmsQty}${coverageYear}${hhmDatesOfBirth}`;

        if(cachedFlows.has(key)) {
            return cachedFlows.get(key);
        } else {
            let output = [];

            let pageIndexInFlow = 0;

            FLOWS[flowType].map((section, sectionIndex) => {

                let pageIndexInCurrentSection = 0;

                processSection(section, sectionIndex, { flowVersion: SSAP_FLOW_VERSION, isExtraFinalSummaryShown })
                    .subSections.forEach((subsection, subsectionIndex) => {
                        if (Array.isArray(subsection)) {
                            Array.from({ length: hhmsQty }).forEach((ent, hhmIdxInLoop) => {
                                const hhm = householdMembers[hhmIdxInLoop] ?? null;

                                subsection.forEach((subsection, sssIndex) => {
                                    const sss = overrideProps({
                                        hhm,
                                        serverDate,
                                        settings,
                                        subsection
                                    });

                                    output = [
                                        ...output,
                                        {
                                            hhm: hhmIdxInLoop,
                                            isActive: true,
                                            pageName: sss.pageName,
                                            formName: sss.formName,
                                            reasons: [],
                                            page: sss,
                                            componentName: getComponentName(sss),
                                            pageIndexInCurrentSection,
                                            pageIndexInFlow,
                                            sectionIndex,
                                            sectionName: section.sectionName,
                                            isTheFirstPageInSection: (subsectionIndex === 0 && hhmIdxInLoop === 0 && sssIndex === 0),
                                        }
                                    ];
                                    pageIndexInCurrentSection++;
                                    pageIndexInFlow++;
                                });
                            });
                        } else {
                            const page = subsection.runtimeOverride
                                ? subsection.runtimeOverride(subsection, coverageYear) : subsection;
                            output = [
                                ...output,
                                {
                                    hhm: -1,
                                    isActive: true,
                                    pageName: page.pageName,
                                    formName: page.formName,
                                    reasons: [],
                                    componentName: getComponentName(page),
                                    page,
                                    pageIndexInCurrentSection,
                                    pageIndexInFlow,
                                    sectionIndex,
                                    sectionName: section.sectionName,
                                    isTheFirstPageInSection: (subsectionIndex === 0)
                                }
                            ];
                            pageIndexInCurrentSection++;
                            pageIndexInFlow++;
                        }

                    });
            });
            cachedFlows.set(key, output);
            return output;
        }
    };
};


// Output

export const getCachedFlows = preparePagesForCurrentFlow();

export const FLOWS = {
    FINANCIAL_FLOW,
    NON_FINANCIAL_FLOW_NON_SWITCHABLE,
    NON_FINANCIAL_FLOW_SWITCHABLE
};
